import { useEffect } from 'react';
import { useModalContext } from 'src/hooks/useModalContext';
import { GPTGameNameType } from '../types';
import { GAMES_CONFIG } from '../config';
import { useApiContext } from 'react-easyrocket';

export const useKillGameOnSessionEnd = (gameName: GPTGameNameType) => {
  const { isAuthenticated } = useApiContext();
  const { closeModal } = useModalContext();

  useEffect(() => {
    if (!isAuthenticated && GAMES_CONFIG[gameName].authOnly) {
      closeModal();
    }
  }, [isAuthenticated]);
};
